/* Louise Nørgaard – ny produktside (sektion: ln-main-product) */
(function () {
  'use strict';

  /* Én global lytter på kurv-kald (fetch + jQuery/XHR) → event 'lnp:cart-changed' */
  if (!window.__lnpCartWatch) {
    window.__lnpCartWatch = true;
    var isCartUrl = function (url) {
      return /\/cart\/(add|change|update|clear)(\.js)?/.test(String(url || ''));
    };
    var notify = function () { document.dispatchEvent(new CustomEvent('lnp:cart-changed')); };

    if (window.fetch) {
      var origFetch = window.fetch;
      window.fetch = function (input) {
        var url = typeof input === 'string' ? input : (input && input.url);
        var p = origFetch.apply(this, arguments);
        if (isCartUrl(url)) p.then(function () { notify(); }, function () {});
        return p;
      };
    }
    var origOpen = XMLHttpRequest.prototype.open;
    XMLHttpRequest.prototype.open = function (method, url) {
      if (isCartUrl(url)) this.addEventListener('loadend', notify);
      return origOpen.apply(this, arguments);
    };
  }

  function init(root) {
    if (!root || root.dataset.lnpReady) return;
    root.dataset.lnpReady = '1';

    var data = JSON.parse(root.querySelector('[data-lnp-json]').textContent);
    var form = root.querySelector('form.lnp-form');
    var idInput = root.querySelector('[data-variant-input]');
    var qtyInput = root.querySelector('[data-qty-input]');
    var atc = root.querySelector('[data-atc]');
    var atcLabel = root.querySelector('[data-atc-label]');
    var addon = root.querySelector('[data-addon]');
    var errorEl = root.querySelector('[data-error]');
    var track = root.querySelector('[data-track]');
    var thumbs = root.querySelectorAll('.lnp-thumb');
    var dots = root.querySelectorAll('.lnp-dot');
    var moneyFormat = root.dataset.moneyFormat || '{{amount_no_decimals_with_comma_separator}} kr';
    var threshold = parseInt(root.dataset.freeThreshold, 10) || 0;
    var atcText = root.dataset.atcText || 'Læg i kurv';

    var current = data.variants.find(function (v) { return String(v.id) === idInput.value; }) || data.variants[0];

    function money(cents) {
      cents = Math.round(cents);
      var fmt = function (n, dec, th, ds) {
        var parts = (n / 100).toFixed(dec).split('.');
        parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, th);
        return parts.length > 1 ? parts[0] + ds + parts[1] : parts[0];
      };
      return moneyFormat.replace(/\{\{\s*(\w+)\s*\}\}/, function (_, key) {
        switch (key) {
          case 'amount': return fmt(cents, 2, ',', '.');
          case 'amount_no_decimals': return fmt(cents, 0, ',', '.');
          case 'amount_with_comma_separator': return fmt(cents, 2, '.', ',');
          case 'amount_no_decimals_with_comma_separator': return fmt(cents, 0, '.', ',');
          case 'amount_no_decimals_with_space_separator': return fmt(cents, 0, ' ', ',');
          case 'amount_with_apostrophe_separator': return fmt(cents, 2, "'", '.');
          default: return fmt(cents, 2, ',', '.');
        }
      });
    }

    function qty() { return Math.max(1, parseInt(qtyInput && qtyInput.value, 10) || 1); }

    function updateAtc() {
      if (!atc) return;
      if (!current || !current.available) {
        atc.disabled = true;
        atcLabel.textContent = current ? 'Udsolgt' : 'Ikke tilgængelig';
        return;
      }
      atc.disabled = false;
      atcLabel.textContent = atcText; // ingen pris på knappen
    }

    /* ---------- Galleri ---------- */
    function setActive(i) {
      thumbs.forEach(function (t) { t.setAttribute('aria-current', String(+t.dataset.index === i)); });
      dots.forEach(function (d) { d.setAttribute('aria-current', String(+d.dataset.index === i)); });
    }
    function goTo(i) {
      if (!track) return;
      track.scrollTo({ left: track.clientWidth * i });
      setActive(i);
    }
    thumbs.forEach(function (t) { t.addEventListener('click', function () { goTo(+t.dataset.index); }); });
    if (track) {
      var raf;
      track.addEventListener('scroll', function () {
        cancelAnimationFrame(raf);
        raf = requestAnimationFrame(function () { setActive(Math.round(track.scrollLeft / track.clientWidth)); });
      }, { passive: true });
      track.addEventListener('keydown', function (e) {
        var i = Math.round(track.scrollLeft / track.clientWidth);
        if (e.key === 'ArrowRight') { e.preventDefault(); goTo(Math.min(i + 1, track.children.length - 1)); }
        if (e.key === 'ArrowLeft') { e.preventDefault(); goTo(Math.max(i - 1, 0)); }
      });
    }

    /* ---------- Varianter ---------- */
    root.querySelectorAll('[data-option-index]').forEach(function (input) {
      input.addEventListener('change', function () {
        var selected = [];
        root.querySelectorAll('[data-option-index]:checked').forEach(function (r) { selected[+r.dataset.optionIndex] = r.value; });
        root.querySelectorAll('[data-option-label]').forEach(function (l) { l.textContent = selected[+l.dataset.optionLabel] || ''; });
        current = data.variants.find(function (v) {
          return v.options.every(function (o, i) { return o === selected[i]; });
        });
        if (current) {
          idInput.value = current.id;
          var url = new URL(window.location.href);
          url.searchParams.set('variant', current.id);
          history.replaceState(null, '', url.toString());

          var priceEl = root.querySelector('[data-price]');
          var compareEl = root.querySelector('[data-compare]');
          var wrap = root.querySelector('[data-price-wrap]');
          var unitEl = root.querySelector('[data-unit-meta]');
          var onSale = current.compare_at_price > current.price;
          if (priceEl) priceEl.textContent = money(current.price);
          if (compareEl) { compareEl.hidden = !onSale; compareEl.textContent = money(current.compare_at_price); }
          if (wrap) wrap.classList.toggle('lnp-price--sale', onSale);
          if (unitEl) unitEl.textContent = current.unit;

          var skuEl = root.querySelector('[data-sku]');
          if (skuEl) skuEl.textContent = current.sku || '';

          var stockCard = root.querySelector('[data-stock-card]');
          if (stockCard) {
            var st = stockCard.querySelector('[data-stock-text]');
            stockCard.classList.toggle('lnp-usp--out', !current.available);
            st.textContent = current.available ? st.dataset.in : st.dataset.out;
          }

          if (current.media_id && track) {
            var slides = Array.prototype.slice.call(track.children);
            var idx = slides.findIndex(function (s) { return s.dataset.mediaId === String(current.media_id); });
            if (idx > -1) goTo(idx);
          }
        }
        updateAtc();
      });
    });

    /* ---------- Antal + tilkøb ---------- */
    root.querySelectorAll('[data-qty]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        qtyInput.value = Math.max(1, qty() + parseInt(btn.dataset.qty, 10));
        updateAtc();
      });
    });
    if (qtyInput) qtyInput.addEventListener('input', updateAtc);
    if (addon) addon.addEventListener('change', updateAtc);

    /* ---------- Fragt-bar ---------- */
    function updateShipping(totalCents) {
      var wrap = root.querySelector('[data-ship]');
      if (!wrap || !threshold) return;
      var text = wrap.querySelector('[data-ship-text]');
      var fill = wrap.querySelector('[data-ship-fill]');
      var rest = threshold - totalCents;
      fill.style.width = Math.min(100, totalCents / threshold * 100) + '%';
      if (totalCents === 0) {
        text.textContent = text.dataset.empty.replace('[grænse]', root.dataset.freeLimit || Math.round(threshold / 100) - 1);
      } else if (rest > 0) {
        text.innerHTML = text.dataset.progress
          .replace('[beløb]', '<strong>').replace('[/beløb]', '</strong>')
          .replace('[rest]', money(rest));
      } else {
        text.textContent = text.dataset.done;
      }
    }

    /* ---------- Læg i kurv ---------- */
    if (form) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        if (!current || !current.available) return;
        errorEl.textContent = '';
        atc.classList.add('is-loading');
        atc.disabled = true;

        var fd = new FormData(form);
        var main = { id: current.id, quantity: qty() };
        var sp = fd.get('selling_plan');
        if (sp) main.selling_plan = sp;
        var props = {};
        fd.forEach(function (val, key) {
          var m = key.match(/^properties\[(.+)\]$/);
          if (m && val !== '') props[m[1]] = val;
        });
        if (Object.keys(props).length) main.properties = props;

        var items = [main];
        if (addon && addon.checked) items.push({ id: parseInt(addon.value, 10), quantity: 1 });

        fetch((window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ items: items })
        })
          .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); })
          .then(function () { return fetch('/cart.js').then(function (r) { return r.json(); }); })
          .then(function (cart) {
            updateShipping(cart.total_price);
            if (addon) addon.checked = false;
            document.dispatchEvent(new CustomEvent('lnp:cart-updated', { detail: { cart: cart } }));
            // Temaets kurv-skuffe (åbner automatisk når der er varer i kurven)
            if (window.theme && theme.miniCart && typeof theme.miniCart.updateElements === 'function') {
              theme.miniCart.updateElements();
              theme.miniCart.generateCart();
            } else {
              window.location.href = '/cart';
            }
          })
          .catch(function (err) {
            errorEl.textContent = (err && (err.description || err.message)) || 'Noget gik galt – prøv igen.';
          })
          .finally(function () {
            atc.classList.remove('is-loading');
            updateAtc();
          });
      });
    }

    /* ---------- Hold fragt-baren i sync med kurven ----------
       Kurv-skuffen (temaet) og apps ændrer kurven uden om denne sektion,
       så vi lytter efter alle kald til /cart/* og henter totalen igen. */
    var syncTimer;
    function refreshShipping() {
      clearTimeout(syncTimer);
      syncTimer = setTimeout(function () {
        fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
          .then(function (r) { return r.json(); })
          .then(function (cart) { updateShipping(cart.total_price); })
          .catch(function () {});
      }, 150);
    }
    document.addEventListener('lnp:cart-changed', refreshShipping);
    window.addEventListener('pageshow', refreshShipping);

    updateAtc();
    refreshShipping();
  }

  // Sticky galleri: læg temaets faste header-højde oven i afstanden fra toppen
  function stickyOffset() {
    var h = document.querySelector('.shopify-section-group-header-group'), top = 0;
    if (h) {
      var cs = getComputedStyle(h);
      if (cs.position === 'sticky' || cs.position === 'fixed') top = Math.max(0, h.offsetHeight + (parseFloat(cs.top) || 0));
    }
    document.documentElement.style.setProperty('--lnp-header-h', top + 'px');
  }
  window.addEventListener('resize', stickyOffset);
  window.addEventListener('load', stickyOffset);

  function boot() { stickyOffset(); document.querySelectorAll('.lnp').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();
